require('features/articleSearchBox');
require('features/articleSearchResultsFacets');
require('features/routing');
require('features/segment');
require('features/googleAnalytics4');
require('./components/pagination/paginationBar');
require('./components/pagination/paginationPageSize');
require('./components/pagination/paginationPage');
require('./handlers/articleCardsHandler');
require('./components/routing/pageUrl');
require('./handlers/featuredArticleHandler');
require('./handlers/articleCardSkeletonHandler');
require('./handlers/navBarHandler');
require('./components/eventTracking/segmentEventsHandler');
require('./components/eventTracking/googleAnalytics4EventsHandler');
require('./handlers/hamburgerMenuHandler');
require('./handlers/hyperlinkCardHandler');

// this is a temporary change load popular pills in the news and trends, this will be removed
// in the future when we have the popularPillsCarousel component ready for rebranding on learning center
require('./handlers/popularPillsHandler');